
import { combineReducers } from '@reduxjs/toolkit'

import standardGradingReducer from './standard-based'

const combinedReducer = combineReducers({

  standardBased: standardGradingReducer,
})

export default combinedReducer
